import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import { tableIcons } from '../../helpers';
import { localization, modifyDefaultOptions } from '../../helpers/table';
import useAPI from '../../hooks/useAPI';
import StatusBadge from '../../components/common/StatusBadge';
import DraggableModal from '../../components/UI/DraggableModal';

export default function BuyVersionHistoryModal({ buy, onClose }) {
  const [data, setData] = useState([]);

  const api = useAPI();

  useEffect(async () => {
    const hists = await api.get(`/buys/${buy.id}/versions`);
    if (!hists.error) setData(hists);
  }, []);

  const columns = [
    {
      title: 'Дата, время', field: 'createdOn', width: '10%', defaultSort: 'desc', render: (rowData) => moment.utc(rowData.createdOn).format('DD.MM.YYYY HH:mm:ss'),
    },
    {
      title: '№ версии',
      field: 'version',
      width: '10%',
      render: (rowData) => (
        <a href={`/strats/${buy.stratId}/projs/${buy.projId}/buys/${rowData.id}`}>
          Версия {rowData.version}
        </a>
      ),
    },
    {
      title: 'Статус',
      field: 'status',
      render: (rowData) => <StatusBadge type="buy" status={rowData.status} width={100} />,
    },
    {
      title: 'Состояние',
      field: 'state',
      render: (rowData) => <StatusBadge type="buyState" status={rowData.state} width={150} />,
    },
    // {title: `Пользователь`, field: 'userName'},
  ];

  return (
    <DraggableModal show={buy} headerNode={`История изменений закупки ${buy.num}`} size="lg" onHide={onClose}>
      <Modal.Body>
        <MaterialTable
          options={modifyDefaultOptions({
            paging: true, toolbar: false, filtering: false, search: false, tableLayout: 'fixed',
          })}
          localization={localization}
          icons={tableIcons}
          columns={columns}
          data={data}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="secondary">Отмена</Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
